console.log('env:', process.env)

document.addEventListener('DOMContentLoaded', () => {

  // DOM elements

  const urlBaseReadonlyInput = document.getElementById('url-base')

  const ecrIdInput = document.getElementById('ecr-id')
  const secretInput = document.getElementById('secret')
  const retrieveTokenButton = document.getElementById('retrieve-token')

  const updateTransactionsButton = document.querySelector('.transactions > h2 > button')
  const terminalIdInput = document.getElementById('terminal-id')
  const terminalIdDatalist = document.getElementById('terminal-ids')
  const transactionIdInput = document.getElementById('transaction-id')
  const autogenerateTidCheckbox = document.getElementById('auto-generated')
  const amountInput = document.getElementById('amount')
  const refreshTerminalsButton = document.getElementById('refresh-terminal-ids')
  const startTransactionButton = document.getElementById('start-transaction')

  const clearApiCallsButton = document.querySelector('.api-calls > h2 > button')

  if (process.env.DEBUG)
    console.info('DOM loaded', {urlBaseReadonlyInput,ecrIdInput,secretInput,retrieveTokenButton,terminalIdInput,terminalIdDatalist,transactionIdInput,transactionIdAutogeneratedCheckbox: autogenerateTidCheckbox,amountInput,refreshTerminalsButton,startTransactionButton,clearApiCallsButton})

  // Load settings

  sessionStorage.removeItem('token')

  createStorage()

  urlBaseReadonlyInput.value = getBaseUrl()

  autogenerateTidCheckbox.checked = loadFromStorage('auto-generated-transaction-id', true)
  if (autogenerateTidCheckbox.checked)
    transactionIdInput.value = generateUuid()

  if (process.env.DEBUG)
    console.info('Settings loaded', JSON.parse(localStorage.getItem('ecrSimulator')))

  // API calls

  const authenticateEcrCall = async (ecrId, secret) => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/auth/rest/ecr/${ecrId}/authenticate`
    const method = 'POST'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
    const requestBody = { secret }

    try {
      const response = await fetch(url, { method, headers, body: JSON.stringify(requestBody) })

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      const data = await response.json()
      addApiCallLogToDom(method, url, requestBody, data)

      return data
    }
    catch (error) {
      addApiCallLogToDom(method, url, requestBody, error.message ?? 'Unknown error')
      console.error('fetchTokenCall:', method, url, requestBody, error)
    }
  }

  const fetchTerminalsCall = async () => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/ecr/rest/terminals`
    const method = 'GET'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      'Accept-Language': 'sl'
    }

    try {
      const response = await fetch(url, { method, headers })

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      const data = await response.json()
      addApiCallLogToDom(method, url, null, data)

      return Array.from(new Map(data.map(t => [t.terminalId, t])).values()) // `data` deduplicated
    }
    catch (error) {
      addApiCallLogToDom(method, url, null, error.message ?? 'Unknown error')
      console.error('fetchTerminalsCall:', method, url, error)
    }
  }

  const startPaymentCall = async (terminalId, ecrTransactionId, amount) => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/ecr/rest/payment`
    const method = 'POST'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      'Accept-Language': 'sl'
    }
    const requestBody = {
      ecrTransactionId,
      terminalId,
      amount,
      currency: 'EUR',
      items: [
        {
          name: 'Test item',
          price: amount,
          quantity: '1',
          tax: '0.22',
          discount: '0'
        }
      ],
      slipFormat: 'IMAGE' // IMAGE, TEXT, DATA, NO_SLIP
    }

    try {
      const response = await fetch(url, { method, headers, body: JSON.stringify(requestBody) })

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      const data = await response.json()
      addApiCallLogToDom(method, url, requestBody, data)

      return data
    }
    catch (error) {
      addApiCallLogToDom(method, url, requestBody, error.message ?? 'Unknown error')
      console.error('startPaymentCall:', method, url, requestBody, error)
    }
  }

  const voidPaymentCall = async (ecrTransactionId) => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/ecr/rest/payment/${ecrTransactionId}/void`
    const method = 'POST'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      'Accept-Language': 'sl',
    }
    const requestBody = {
      // ecrTransactionId: "new transaction id for void transaction",
      // slipFormat: "IMAGE", // IMAGE, TEXT, DATA, NO_SLIP
      // mustAcceptBy: "2021-01-01T00:00:00.000Z"
    }

    try {
      console.log('starting voidPaymentCall')
      const response = await fetch(url, { method, headers, body: JSON.stringify(requestBody) })
      console.info('response:', response)

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      const data = await response.json()
      addApiCallLogToDom(method, url, requestBody, data)

      return data
    }
    catch (error) {
      addApiCallLogToDom(method, url, requestBody, error.message ?? 'Unknown error')
      console.error('voidPaymentCall:', method, url, requestBody, error)
    }
  }

  const resendPaymentNotificationCall = async (ecrTransactionId) => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/ecr/rest/payment/${ecrTransactionId}/resend-notification`
    const method = 'POST'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      'Accept-Language': 'sl'
    }

    try {
      const response = await fetch(url, { method, headers })

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      addApiCallLogToDom(method, url, null, 'Request accepted (202)')
      return {}
    }
    catch (error) {
      addApiCallLogToDom(method, url, null, error.message ?? 'Unknown error')
      console.error('resendPaymentNotificationCall:', method, url, error)
    }
  }

  const cancelPaymentCall = async (ecrTransactionId) => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/ecr/rest/payment/${ecrTransactionId}/cancel`
    const method = 'POST'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      'Accept-Language': 'sl'
    }

    try {
      const response = await fetch(url, { method, headers })

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      addApiCallLogToDom(method, url, null, 'Request accepted (202)')
      return {}
    }
    catch (error) {
      addApiCallLogToDom(method, url, null, error.message ?? 'Unknown error')
      console.error('cancelPaymentCall:', method, url, error)
    }
  }

  const fetchPaymentCall = async (ecrTransactionId) => {

    const url = `${urlBaseReadonlyInput.value}/payment-gateway/ecr/rest/payment/${ecrTransactionId}`
    const method = 'GET'
    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
      'Accept-Language': 'sl'
    }

    try {
      const response = await fetch(url, { method, headers })

      if (!response.ok) {
        if (process.env.DEBUG)
          console.error('response:', response.status, await response.text())
        return
      }

      const data = await response.json()
      addApiCallLogToDom(method, url, null, data)

      return data
    }
    catch (error) {
      addApiCallLogToDom(method, url, null, error.message ?? 'Unknown error')
      console.error('fetchPaymentCall:', method, url, error)
    }
  }

  // On-event handlers

  const handleRetrieveTokenClick = async () => {

    const ecrId = ecrIdInput.value
    const secret = secretInput.value

    const token = await authenticateEcrCall(ecrId, secret)
    if (!token) {
      showNotification('Authentication failed', 'error')
      return
    }
    showNotification('Token stored in session', 'success')

    sessionStorage.setItem('token', token.jwt)
    retrieveTokenButton.disabled = true

    handleRefreshTerminalsButtonClick()
  }

  const handleRefreshTerminalsButtonClick = async () => {

    const terminals = await fetchTerminalsCall()
    if (!terminals) {
      showNotification('Fetching terminal IDs failed', 'error')
      return
    }
    showNotification('List of terminal IDs refreshed', 'success')

    populateTerminalIdsDataset(terminals)
  }

  const handleUpdateTransactionsButtonClick = async () => {

    document
      .querySelectorAll('.transactions-container > .transaction')
      .forEach(async (transactionElement) => {

        const transactionId = transactionElement.querySelector('.transaction-id').textContent
        const updatedTransaction = await fetchPaymentCall(transactionId)
        if (!updatedTransaction) {
          showNotification(`Update failed for transaction "${transactionId}"`, 'error')
          return
        }

        const statusElement = transactionElement.querySelector('.transaction-status')
        if (statusElement.textContent != updatedTransaction.status) {
          statusElement.textContent = updatedTransaction.status
          statusElement.dataset.status = updatedTransaction.status.toLowerCase()

          const actionsElement = transactionElement.querySelector('.transaction-actions')
          actionsElement.innerHTML = ''
          if (updatedTransaction.status == 'SUCCESS') {
            const button = document.createElement('button')
            button.textContent = 'Void'
            button.addEventListener('click', async () => handleVoidActionClick(updatedTransaction.ecrTransactionId))
            actionsElement.appendChild(button)
          }
          if (updatedTransaction.status == 'RECEIVED') {
            const button = document.createElement('button')
            button.textContent = 'Resend notification'
            button.addEventListener('click', async () => handleResendNotificationActionClick(updatedTransaction.ecrTransactionId))
            actionsElement.appendChild(button)

            const button2 = document.createElement('button')
            button2.textContent = 'Cancel'
            button2.addEventListener('click', async () => handleCancelActionClick(updatedTransaction.ecrTransactionId))
            actionsElement.appendChild(button2)
          }
        }

        if (updatedTransaction.failureReason)
          transactionElement.querySelector('.transaction-details').innerHTML = updatedTransaction.failureReason

        showNotification(`Updated transaction "${transactionId}"`,'success')
      })
  }

  const handleStartTransactionButtonClick = async () => {

    const terminalId = terminalIdInput.value
    const transactionId = transactionIdInput.value
    const amount = parseFloat(amountInput.value)

    const transaction = await startPaymentCall(terminalId, transactionId, amount)
    if (!transaction) {
      showNotification('Starting payment failed', 'error')
      return
    }
    showNotification('Payment started', 'success')

    addTransactionToDom(transaction)
  }

  const handleVoidActionClick = async () => {

    const ecrTransactionId = transactionIdInput.value

    const transaction = await voidPaymentCall(ecrTransactionId)
    if (!transaction) {
      showNotification('Voiding payment failed', 'error')
      return
    }
    showNotification('Payment voided', 'success')

    addTransactionToDom(transaction)
  }

  const handleResendNotificationActionClick = async (ecrTransactionId) => {

    const transaction = await resendPaymentNotificationCall(ecrTransactionId)
    if (!transaction) {
      showNotification('Resending payment notification failed', 'error')
      return
    }
    showNotification('Payment notification resent','success')
  }

  const handleCancelActionClick = async (ecrTransactionId) => {

    const transaction = await cancelPaymentCall(ecrTransactionId)
    if (!transaction) {
      showNotification('Cancelling payment failed', 'error')
      return
    }
    showNotification('Payment cancelled', 'success')
  }

  const handleClearApiCallsButtonClick = () => {

    const heading = document.querySelector('.api-calls h2')

    let element = heading.nextElementSibling

    while (element) {
      const next = element.nextElementSibling
      element.remove()
      element = next
    }

    showNotification('API calls cleared', 'success')
  }

  const handleTerminalIdInputFocus = () => terminalIdInput.value = ''

  const handleTransactionIdInputFocus = () => {
    if (loadFromStorage('auto-generated-transaction-id'))
      transactionIdInput.value = generateUuid()
    transactionIdInput.select()
  }

  const handleAutogenerateTidCheckboxChange = () =>
    saveToStorage('auto-generated-transaction-id', autogenerateTidCheckbox.checked)

  // Event listeners

  retrieveTokenButton.addEventListener('click', handleRetrieveTokenClick)
  terminalIdInput.addEventListener('focus', handleTerminalIdInputFocus)
  transactionIdInput.addEventListener('focus', handleTransactionIdInputFocus)
  refreshTerminalsButton.addEventListener('click', handleRefreshTerminalsButtonClick)
  autogenerateTidCheckbox.addEventListener('change', handleAutogenerateTidCheckboxChange)
  updateTransactionsButton.addEventListener('click', handleUpdateTransactionsButtonClick)
  startTransactionButton.addEventListener('click', handleStartTransactionButtonClick)
  clearApiCallsButton.addEventListener('click', handleClearApiCallsButtonClick)

  // DOM manipulations

  async function populateTerminalIdsDataset(terminals) {

    terminalIdDatalist.innerHTML = ''
    terminals.forEach(terminal => {
      terminalIdDatalist.innerHTML += `<option value="${terminal.terminalId}">${terminal.name}</option>`
    })
    terminalIdInput.placeholder = 'Select a terminal'
  }

  async function addTransactionToDom(transaction) {

    const transactionsList = document.querySelector('.transactions-container')

    const newTransaction = document.createElement('div')
    newTransaction.classList.add('transaction')

    newTransaction.innerHTML = `
      <div class="transaction-time">${formattedDateTime()}</div>
      <div class="transaction-id">${transaction.ecrTransactionId}</div>
      <div class="transaction-amount">${formattedEur(transaction.amount)}</div>
      <div class="transaction-status" data-status="${transaction.status.toLowerCase()}">${transaction.status}</div>`

    const details = document.createElement('div')
    details.classList.add('transaction-details')
    details.textContent = transaction.failureReason
    newTransaction.appendChild(details)

    const actions = document.createElement('div')
    actions.classList.add('transaction-actions')
    if (transaction.status == 'SUCCESS') {
      const button = document.createElement('button')
      button.textContent = 'Void'
      button.addEventListener('click', async () => handleVoidActionClick(transaction.ecrTransactionId))
      actions.appendChild(button)
    }
    if (transaction.status == 'RECEIVED') {
      const button = document.createElement('button')
      button.textContent = 'Resend notification'
      button.addEventListener('click', async () => handleResendNotificationActionClick(transaction.ecrTransactionId))
      actions.appendChild(button)

      const button2 = document.createElement('button')
      button2.textContent = 'Cancel'
      button2.addEventListener('click', async () => handleCancelActionClick(transaction.ecrTransactionId))
      actions.appendChild(button2)
    }

    newTransaction.appendChild(actions)
    transactionsList.appendChild(newTransaction)
  }

  async function addApiCallLogToDom(method, endpoint, requestBody = null, responseBody = null) {

    const apiCalls = document.querySelector('.api-calls')
    const newApiCall = document.createElement('div')
    newApiCall.classList.add('api-call')

    const callTimeElement = document.createElement('pre')
    callTimeElement.classList.add('call-time')
    callTimeElement.textContent = formattedDateTime()
    newApiCall.appendChild(callTimeElement)

    const endpointElement = document.createElement('pre')
    endpointElement.classList.add('endpoint')
    endpointElement.textContent = method + ' ' + endpoint
    newApiCall.appendChild(endpointElement)

    if (requestBody) {
      const requestElement = document.createElement('pre')
      requestElement.classList.add('request')
      requestElement.textContent = 'REQUEST\n' + JSON.stringify(requestBody, null, 2)
      newApiCall.appendChild(requestElement)
    }

    if (responseBody) {
      const responseElement = document.createElement('pre')
      responseElement.classList.add('response')
      responseElement.textContent = 'RESPONSE\n' + JSON.stringify(responseBody, null, 2)
      newApiCall.appendChild(responseElement)
    }

    apiCalls.appendChild(newApiCall)
  }

  async function showNotification(message, type) {

    const container = document.getElementById('notification-container')
    const notification = document.createElement('div')

    notification.classList.add('notification', type)
    notification.textContent = message

    container.appendChild(notification)

    setTimeout(() => {
      notification.style.animation = 'fadeOut 0.5s forwards'
      setTimeout(() => notification.remove(), 500) // Same as above: 0.5s
    }, 10_000)
  }
})

// Local storage

function createStorage() {

  if (!localStorage.getItem('ecrSimulator'))
    localStorage.setItem('ecrSimulator', JSON.stringify({}))
}

function saveToStorage(key, value) {

  const storageItem = localStorage.getItem('ecrSimulator')
  const settings = storageItem ? JSON.parse(storageItem) : {}
  settings[key] = value
  localStorage.setItem('ecrSimulator', JSON.stringify(settings))
}

function loadFromStorage(key, fallback = null) {

  const storageItem = localStorage.getItem('ecrSimulator')
  const settings = JSON.parse(storageItem)
  if (!(key in settings)) {
    saveToStorage(key, fallback)
    return fallback
  }
  return settings[key]
}

// Miscellaneous

function getBaseUrl() {

  const apiUrls = {
    dev: 'https://dev-api.lab4pay.rocks',
    test: 'https://staging-api.lab4pay.rocks',
    prod: 'https://api.lab4pay.rocks',
  }

  // Get from query parameter
  const params = new URLSearchParams(window.location.search)
  const apiParam = params.get('api')
  console.log(apiParam)
  if (apiParam != null)
    saveToStorage('api-source', apiParam)
  if (['dev', 'test', 'prod'].includes(apiParam))
    return apiUrls[apiParam]

  // Get from local storage
  const localParam = loadFromStorage('api-source')
  if (['dev', 'test', 'prod'].includes(localParam)) {
    return apiUrls[localParam]
  }

  // Get from base URL
  const hostname = window.location.hostname
  if (hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1')) {
    saveToStorage('api-source', 'dev')
    return apiUrls.dev
  }
  if (hostname.startsWith('dev-')) {
    saveToStorage('api-source', 'dev')
    return apiUrls.dev
  }
  if (hostname.startsWith('staging-')) {
    saveToStorage('api-source', 'test')
    return apiUrls.test
  }
  saveToStorage('api-source', 'prod')
  return apiUrls.prod
}

function formattedDateTime(date = null) {

  if (!date)
    date = new Date().getTime()

  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }
  const formatter = new Intl.DateTimeFormat('sl-SI', options)
  return formatter.format(date)
}

function formattedEur(amount = null) {

  if (!amount)
    amount = 0

  const options = {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }
  const formatter = new Intl.NumberFormat('sl-SI', options)
  return formatter.format(amount)
}

function generateUuid() {

  try {
    return crypto.randomUUID()
  }
  catch (error) {
    // https://stackoverflow.com/a/2117523/9583480
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    )
  }
}
